<template>
  <div
    :style="{ 'z-index': getPopupZindex }"
    :class="{ 'payment-status-popup': true, 'is-visible': isVisible }">
    <h2>{{ $t('paymentStatusPopup.title') }}</h2>

    <message
      v-if="isCyclic"
      type="warning">
      <strong>
        {{ $t('paymentStatusPopup.warning') }}
      </strong>

       {{ $t('paymentStatusPopup.inquiryIsCyclic') }}
    </message>

    <field type="full-width">
      <label slot="label">
        {{ $t('paymentStatusPopup.status') }}
      </label>

      <select
        slot="field"
        v-model="status"
        :disabled="loadingData">
        <option v-if="!isCash" value="NEW">{{ $t('paymentStatusPopup.statusNew') }}</option>
        <option v-if="!isCash" value="PENDING">{{ $t('paymentStatusPopup.statusPending') }}</option>
        <option value="COMPLETED">{{ $t('paymentStatusPopup.statusCompleted') }}</option>
        <option v-if="!isCash" value="CANCELED">{{ $t('paymentStatusPopup.statusCancelled') }}</option>
        <option v-if="isCash" value="CASH">{{ $t('common.ui.paidWithCash') }}</option>
      </select>
    </field>

    <field type="full-width">
        <label slot="label">
          {{ $t('paymentStatusPopup.notifyClient') }}
        </label>

        <switcher
          slot="field"
          key="notify-client-switcher"
          :disabled="loadingData"
          v-model="notify" />
    </field>

    <btn
      @click.native="saveStatus"
      :disabled="loadingData"
      type="popup-left primary">
      <template v-if="!loadingData">{{ $t('paymentStatusPopup.changeStatus') }}</template>
      <template v-if="loadingData">{{ $t('paymentStatusPopup.saving') }}</template>
    </btn>

    <btn
      @click.native="cancel"
      type="popup-right">
      {{ $t('common.ui.cancel') }}
    </btn>
  </div>
</template>

<script>
import ErrorUtils from './../helpers/ErrorUtils.js';
import PopupZindex from './../mixins/PopupZindex';

export default {
  name: 'payment-status-popup',
  mixins: [
    PopupZindex
  ],
  data () {
    return {
      id: 0,
      status: '',
      isCash: false,
      isCyclic: false,
      notify: false,
      isVisible: false,
      loadingData: false
    };
  },
  mounted () {
    this.$bus.$on('show-payment-status-form', this.show);
  },
  methods: {
    show (data) {
      this.id = data.id;
      this.isCyclic = data.isCyclic;
      this.status = data.status;
      this.isCash = data.isCash;
      this.isVisible = true;
      this.increasePopupZindex();
    },
    hide () {
      this.isVisible = false;
      this.loadingData = false;
      this.removePopupZindex();
    },
    saveStatus () {
      let statusData = {
        id: this.id,
        status: this.status,
        notify: this.notify
      };

      this.loadingData = true;

      this.$http.post('/panel/reservations/change-payment-status', statusData).then(response => {
        this.$bus.$emit('reservation-details-popup-reload-needed');
        this.$bus.$emit('payments-history-reload-needed');
        this.loadingData = false;
        this.hide();

        this.$bus.$emit('notification-display', {
          type: 'success',
          message: this.$t('paymentStatusPopup.statusChanged')
        });
      }).catch(error => {
        ErrorUtils.handleSubmitError(error, '/panel/reservations/change-payment-status', this.$router, this.$bus, this.saveStatus.bind(this));
        this.loadingData = false;
      });
    },
    cancel () {
      this.hide();
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-payment-status-form', this.show);
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.payment-status-popup {
  background: $color-light;
  border-radius: $border-radius-small;
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, .125);
  display: none;
  left: 50%;
  max-width: 94%;
  padding: 3rem 4rem 8rem 4rem;
  position: fixed;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 480px;

  &.is-visible {
    display: block;
  }

  h2 {
    font-weight: 400;
    line-height: 1;
    margin: 0 0 2rem 0;
  }

  .button-popup-left {
    border-radius: 0 0 0 $border-radius-small;
  }

  .button-popup-right {
    border-radius: 0 0 $border-radius-small 0;
  }

  .field {
    flex-wrap: nowrap;

    label {
      margin-bottom: .5rem;
      padding-right: 0;
      text-align: left;
      width: 50%;
    }

    select {
        width: 50%!important;
    }
  }
}

@media (max-width: 480px) {
  .payment-status-popup {
    height: 100%;
    max-width: 100%;
    padding: 1.5rem 1.5rem 5rem 1.5rem;
    width: 100%;

    h2 {
      font-size: 2rem;
      margin-bottom: 1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/PaymentStatusPopup.vue